module.exports = __webpack_public_path__ + "images/018eb3e9ac3aecde2f029a68bf07c531-warning.png";